import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import {Http, RequestOptions, Headers} from '@angular/http';
import 'rxjs/add/operator/map';

import {StorageService} from "./storage";
import {GetNewsService} from "./get-news-service";

@Injectable()
export class SocialService {
  userId;
  currentServerId;
  server;

  constructor(
    public http: HttpClient,
    private storageService: StorageService,
    private getNewsService: GetNewsService
  ) {}

  checkStatus() {
    const url = this.generateServerUrl('general', false) + 'check_status';
    return this.http.get(url)
      .map((data: any) => data);
  }

  public login(userId) {
    let params = new HttpParams();
    params = params.append('userId', this.userId);
    const url = this.generateServerUrl('general') + 'login';
    this.http.get(url, { params: params })
      .subscribe((data: any) => {
        this.storageService.set('socialEnabled', data['twitterUser']['enabled']);
        this.storageService.set('socialUserId', data['twitterUser']['userId']);
        this.userId = data['twitterUser']['userId'];
      });
  }

  public logout() {
    const url = this.generateServerUrl('general') + 'logout';
    return this.http.get(url)
      .map((data: any) => data);
  }

  public disconnect() {
    const url = this.generateServerUrl('general') + 'twitter';
    this.http.delete(url)
      .subscribe((data) => {
        this.storageService.set('socialEnabled', false);
        this.storageService.set('socialUserId', 0);
        this.userId = 0;
      });
  }

  public userSettings() {
    const url = this.generateServerUrl('general') + 'userSettings';
    return this.http.get(url)
      .map((data: any) => data);
  }


  public userSettingsSave(parameters: any) {
    // TODO check
    let params = new HttpParams();
    params = params.append('userId', this.userId);
    params = params.append('primaryEmail', parameters.primaryEmail);
    params = params.append('secondaryEmail', parameters.secondaryEmail);
    params = params.append('replyEmail', parameters.replyEmail);
    params = params.append('replyName', parameters.replyName);
    params = params.append('senderEmail', parameters.senderEmail);
    params = params.append('senderName', parameters.senderName);
    params = params.append('alertVerifiedOnly', parameters.alertVerifiedOnly);
    params = params.append('emailVerifiedOnly', parameters.emailVerifiedOnly);
    const url = this.generateServerUrl('general') + 'login';
    return this.http.get(url, { params: params })
      .map((data: any) => data);
  }

  keywordsGetExpression() {

  }

  public addKeyword(keyword) {
    let params = new HttpParams();
    for (const p in keyword) {
      if (keyword.hasOwnProperty(p)) {
        params = params.append(p, keyword[p]);
      }
    }
    const url = this.generateServerUrl('general') + 'keywords';
    return this.http.get(url, {params: params})
      .map((data: any) => data);
  }

  public getKeyword(id) {
    const url = this.generateServerUrl('general') + 'keywords/' + id;
    return this.http.get(url)
      .map((data: any) => data);
  }

  public getKeywords() {
    const url = this.generateServerUrl('general') + 'keywords';
    return this.http.get(url)
      .map((data: any) => data);
  }

  public getSharedKeywords() {
    const url = this.generateServerUrl('general', true, '-1') + 'keywords';
    return this.http.get(url)
      .map((data: any) => data);
  }

  public updateKeyword(keyword) {
    let params = new HttpParams();
    for (const p in keyword) {
      if (keyword.hasOwnProperty(p)) {
        params = params.append(p, keyword[p]);
      }
    }
    const url = this.generateServerUrl('general') + 'keywords/' + keyword.id;
    return this.http.get(url, {params: params})
      .map((data: any) => data);
  }

  public deleteKeyword(id) {
    const url = this.generateServerUrl('general') + 'keywords/' + id;
    return this.http.delete(url)
      .map((data: any) => data);
  }

  public status(queryParams) {
    let params = new HttpParams();
    for (const p in queryParams) {
      if (queryParams.hasOwnProperty(p)) {
        params = params.append(p, queryParams[p]);
      }
    }
    const url = this.generateServerUrl('status') + 'statuses';
    return this.http.get(url, {params: params})
      .map((data: any) => data);
  }

  public alarms(sinceId) {
    let params = new HttpParams();
    params = params.append('userId', this.userId);
    params = params.append('sinceId', sinceId);
    const url = this.generateServerUrl('status') + 'alarms';
    return this.http.get(url, { params: params })
      .map((data: any) => data);
  }

  public auth_url() {
    const url = this.generateServerUrl('twitter', false) + 'auth_url';
    return this.http.get(url)
      .map((data: any) => data);
  }

  public store_twitter_pin(userId, twitterUserId, pin) {
    let params = new HttpParams();
    params = params.append('twitterUserId', twitterUserId);
    params = params.append('pin', pin);
    const url = this.generateServerUrl('twitter') + 'store_twitter_pin';
    return this.http.get(url, { params: params })
      .map((data: any) => data);
  }

  public getUserInfo() {
    const url = this.generateServerUrl('twitter');
    return this.http.get(url)
      .map((data: any) => data);
  }

  public findUsers(q: string) {
    let params = new HttpParams();
    params = params.append('q', q);
    params = params.append('page', '1');
    const url = `${this.generateServerUrl('twitter')}findUsers`;
    return this.http.get(url, { params: params })
      .map((data: any) => data);
  }

  public getFollowings() {
    let params = new HttpParams();
    params = params.append('force', '1');
    const url = `${this.generateServerUrl('twitter')}followings`;
    return this.http.get(url, { params: params })
      .map((data: any) => data);
  }

  public getSharedFollowings() {
    let params = new HttpParams();
    params = params.append('force', '1');
    const url = `${this.generateServerUrl('twitter')}shared_followings`;
    return this.http.get(url, { params: params })
      .map((data: any) => data);
  }

  public updateFollowings(followings) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    const url = this.generateServerUrl('twitter') + 'followings';
    const body = `followings=[${JSON.stringify(followings)}]`;
    return this.http.post(url, body, options)
      .map((data: any) => data);
  }

  private generateServerUrl(root, withUserId = true, customId = null) {
    if (typeof this.storageService.get('currentServer') === 'undefined') {
      this.server = null;
    } else {
      this.currentServerId = this.storageService.get('currentServer');
      this.userId = this.storageService.get('userId');
      if (root == 'twitter') {
        if (withUserId) {
          if (customId == null) {
            return this.getNewsService.generateBaseUrl() + '/GetSocial/api/' + root + '/users/' + this.userId + '/'
          } else {
            return this.getNewsService.generateBaseUrl() + '/GetSocial/api/' + root + '/users/' + customId + '/'
          }
        } else {
          return this.getNewsService.generateBaseUrl() + '/GetSocial/api/' + root + '/'
        }

      } else {
        if (withUserId) {
          if (customId == null) {
            return this.getNewsService.generateBaseUrl() + '/GetSocial/api/' + root + '/users/' + this.userId + '/'

          } else {
            return this.getNewsService.generateBaseUrl() + '/GetSocial/api/' + root + '/users/' + customId + '/'

          }

        } else {
          return this.getNewsService.generateBaseUrl() + '/GetSocial/api/' + root + '/users/'

        }
      }
    }
  }

}




// WEBPACK FOOTER //
// ./src/providers/social-service.ts